// @core/api/endpoints/project/list_epics.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListEpicsResponse,
} from '../../../types/project';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/project';

/**
 * List epics
 * Returns all epics in the project with progress information based on their associated items.
 */
export async function ListEpics(
  project_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListEpicsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/epics`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  const requestOptions = options;
  return client.get<ListEpicsResponse>(requestPath, { ...requestOptions, params });
}
